import { render } from "./headerBar.vue?vue&type=template&id=6ca7aaaa"
import script from "./headerBar.vue?vue&type=script&lang=js"
export * from "./headerBar.vue?vue&type=script&lang=js"

import "./headerBar.vue?vue&type=style&index=0&id=6ca7aaaa&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__